(() => {
  const script = document.currentScript;
  const root = script?.dataset.root || '/';
  let count = Number(script?.dataset.cartCount || 0);
  let requestId = 0;
  const paint = () => {
    document.querySelectorAll('[data-daisy-header-shop]').forEach(link => { link.hidden = count > 0; });
    document.querySelectorAll('[data-daisy-header-bag]').forEach(link => {
      link.hidden = count === 0;
      link.setAttribute('aria-label', `Open bag, ${count} ${count === 1 ? 'item' : 'items'}`);
    });
  };
  const refresh = async () => {
    const id = ++requestId;
    try {
      const response = await fetch(`${root}cart.js`, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (id !== requestId || !Number.isFinite(cart.item_count)) return;
      count = cart.item_count;
      paint();
    } catch { /* Keep the last confirmed cart state when offline. */ }
  };
  paint();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (Number.isFinite(event?.cartData?.item_count)) {
        ++requestId;
        count = event.cartData.item_count;
        paint();
      } else return refresh();
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-daisy-header-bag]');
    const drawer = document.querySelector('cart-drawer');
    if (!link || link.hidden || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || typeof drawer?.open !== 'function') return;
    event.preventDefault();
    drawer.open(link);
  });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('shopify:section:load', refresh);
  // Section rendering can update the cart count before the drawer emits its event.
  const cartBubble = document.getElementById('cart-icon-bubble');
  if (cartBubble) new MutationObserver(refresh).observe(cartBubble, {childList:true,subtree:true,characterData:true});
})();
